"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

var _underscore = _interopRequireDefault(require("underscore"));

var _backbone = _interopRequireDefault(require("backbone"));

var _backboneValidation = _interopRequireDefault(require("backbone-validation"));

var _bootstrapMultiselect = _interopRequireDefault(require("../plugins/bootstrap-multiselect/bootstrap-multiselect"));

var _TrackingMixin = _interopRequireDefault(require("./TrackingMixin"));

var _jqueryPlaceholder = _interopRequireDefault(require("jquery-placeholder"));

var _icheck = _interopRequireDefault(require("../plugins/icheck/icheck"));

var _bootstrapSelect = _interopRequireDefault(require("../plugins/bootstrap-select/bootstrap-select.min"));

var _jquery2 = _interopRequireDefault(require("../plugins/datetimepicker/jquery.datetimepicker"));

var _bootstrapSlider = _interopRequireDefault(require("../plugins/bootstrap-slider/js/bootstrap-slider"));

var _ladda = _interopRequireDefault(require("ladda"));

var _LinkSpinner = _interopRequireDefault(require("./LinkSpinner"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SaveButtonMixin = {
  initSaveButton: function initSaveButton(button, options) {
    options = options || {};
    var model = options.model || this.model;

    if (!button) {
      return;
    }

    var isLink = false;

    if ((0, _jquery.default)(button).prop('tagName') === 'A') {
      isLink = true;
    }

    var thisView = this;
    button.each(function () {
      var thisButton = this;
      var ladda, linkSpinner;
      thisView.listenTo(model, 'request:update request:create', function () {
        if (isLink) {
          linkSpinner = _LinkSpinner.default.create(thisButton);
          linkSpinner && linkSpinner.start();
        } else {
          (0, _jquery.default)(thisButton).addClass('ladda-button').attr('data-style', 'slide-up');
          ladda = _ladda.default.create(thisButton);
          ladda && ladda.start();
        }
      });
      thisView.listenTo(model, 'error', function () {
        if (isLink) {
          linkSpinner && linkSpinner.stop();
        } else {
          ladda && ladda.error();
        }
      });
      thisView.listenTo(model, 'sync', function () {
        if (isLink) {
          linkSpinner && linkSpinner.stop();
        } else {
          ladda && ladda.success();
        }
      });
    });
  }
};
var FormViewMixin = {
  initValidation: function initValidation(options) {
    if (this._formViewMixinInitiated) {
      return;
    }

    this._formViewMixinInitiated = true;
    this.changeFunctions = [];
    var enhance = {
      select: true,
      icheck: true,
      placeholder: true,
      tooltip: true,
      multiselect: false
    };
    this._formViewMixinOptions = _underscore.default.extend({
      attrs: [],
      // Attributes to 2-way-bind to form fields
      liveKeyup: false,
      // Update models on each keyup
      tracking: true,
      // Track or do not track changes for trackModels
      trackModels: [this.model],
      // models to track for unsaved changes
      handleSave: true,
      // false when the model should not be saved
      handleSaveHandler: false,
      // Should pass a function func(options), in the end must call this.saveHandlerCompleted()
      ignoreKeyUp: ['localValues'] // For these fields keyUp event will be ignored

    }, options);

    _backbone.default.Validation.bind(this, {
      forceUpdate: true,
      valid: this._valid,
      invalid: this._invalid
    });

    this._formViewMixinOptions.enhance = _underscore.default.extend(enhance, options && options.enhance);
    this._formViewMixinOptions.tracking && this._bindModelForChanges(this._formViewMixinOptions.trackModels);
    this._formViewMixinOptions.handleSave && this._setModelForSave(this.model);
    this._formViewMixinOptions.handleSaveHandler && this._setHandleSaveHandler(this._formViewMixinOptions.handleSaveHandler);
    this._formViewMixinOptions.attrs && this._bindModelToView(this._formViewMixinOptions.attrs);
    this._formViewMixinOptions.attrs && this._bindViewToModel(this._formViewMixinOptions.attrs, this._formViewMixinOptions.ignoreKeyUp);

    this._wrapRemove();
  },
  removeValidation: function removeValidation() {
    if (!this._formViewMixinInitiated) {
      return;
    }

    this._unbindModelForChanges();

    _backbone.default.Validation.unbind(this);

    this._formViewMixinInitiated = false;
  },
  applyIcheck: function applyIcheck() {
    var checks = this.$('input:not(.no-icheck)');
    checks.icheck('destroy');
    checks.icheck({
      checkboxClass: 'icheckbox_square-grey',
      radioClass: 'iradio_square-grey'
    });
  },
  applyMultiSelect: function applyMultiSelect(className, icheckEnabled) {
    var cssClass = className || 'custom-multi-select';
    var $el = this.$('.' + cssClass);
    var buttonContainerClass = $el.attr('data-buttonContainerClass') || '';
    var staticDD = $el.attr('data-staticDD');
    var ul = staticDD ? '<ul class="multiselect-container dropdown-menu dd-shadow ' + staticDD + '"' + '></ul>' : '<ul class="multiselect-container dropdown-menu dd-shadow"></ul>';
    $el.multiselect('destroy');
    $el.multiselect({
      buttonClass: 'btn btn-form-dropdown form-control',
      numberDisplayed: $el.attr('data-numberDisplayed') || 2,
      selectedClass: null,
      enableFiltering: true,
      enableCaseInsensitiveFiltering: true,
      nonSelectedText: $el.attr('data-defaultText') || $el.attr('data-nonSelectedText') || ' Please Select ',
      buttonWidth: '100%',
      buttonContainer: '<div class="btn-group bootstrap-select form-control input-sm ' + buttonContainerClass + '" />',
      includeSelectAllOption: $el.attr('data-includeSelectAllOption') ? true : false,
      selectAllText: $el.attr('data-selectedAllText') || 'Select All',
      maxHeight: 300,
      templates: {
        ul: ul,
        divider: '<li class="multiselect-item divider dropdown-divider"></li>',
        li: '<li class="select-item"><a href="javascript:void(0);"><label class="select-label"></label></a></li>',
        filter: '<li class="multiselect-item filter"><div class="dropDownTitle input-group"><span class="dropdown-search input-group-addon"><i class="icon icon-search" style="font-size:25px;"></i></span><input class="form-control multiselect-search" type="text"></div></li>'
      },
      onChange: _underscore.default.bind(this._multiSelectChanged, this)
    });
    var enhanceCheck = icheckEnabled || this._formViewMixinOptions && this._formViewMixinOptions.enhance && this._formViewMixinOptions.enhance.icheck;

    _underscore.default.each(this.$('.' + cssClass), function (multiselect) {
      var currentMultiselect = (0, _jquery.default)(multiselect);
      var data = currentMultiselect.data('multiselect');
      var orgSelect = data.select;

      if (currentMultiselect && (currentMultiselect.attr('data-nonselectedtext') || currentMultiselect.attr('data-numberDisplayed'))) {
        var numberDisplayed = $el.attr('data-numberDisplayed') || 2;
        currentMultiselect.multiselect('setOptions', {
          nonSelectedText: currentMultiselect.attr('data-nonselectedtext'),
          numberDisplayed: numberDisplayed
        });
        currentMultiselect.multiselect('rebuild');
      }

      data.select = function (selectValues) {
        var i;
        var $checkbox; // verify all values have checkboxes

        for (i = 0; i < selectValues.length; i++) {
          if (!selectValues[i]) {
            return;
          }

          $checkbox = data.getInputByValue(selectValues[i]);

          if (!$checkbox) {
            return;
          }
        } // Call original select


        orgSelect.call(data, selectValues); // Update iCheck state

        if (enhanceCheck) {
          for (i = 0; i < selectValues.length; i++) {
            $checkbox = data.getInputByValue(selectValues[i]);
            $checkbox.icheck('updated');
          }
        }
      };
    });
  },
  applySelectpicker: function applySelectpicker() {
    var $el = this.$('.selectpicker');
    var nonSelectedText = $el.attr('data-nonSelectedText');
    this.$('select.selectpicker').selectpicker({
      style: 'form-control btn-form-dropdown',
      dropupAuto: $el.attr('data-dropupAuto') || false,
      size: 6,
      noneSelectedText: nonSelectedText || ' Please Select '
    });
  },
  applyChangeFunctions: function applyChangeFunctions() {
    _underscore.default.each(this.changeFunctions, function (changeFunction) {
      changeFunction.call(this);
    }, this);
  },
  renderForm: function renderForm() {
    if (!this._formViewMixinOptions) {
      return;
    }

    this._formViewMixinOptions.enhance.placeholder && this.$('input[placeholder], textarea[placeholder]').placeholder();

    if (this._formViewMixinOptions.enhance.multiselect) {
      this.applyMultiSelect();
    }

    if (this._formViewMixinOptions.enhance.icheck) {
      this.applyIcheck();
    }

    if (this._formViewMixinOptions.enhance.select) {
      this.applySelectpicker();
    }

    if (this._formViewMixinOptions.enhance.tooltip) {
      this.$('icon.help-icon').tooltip({
        container: 'body',
        placement: 'top',
        html: true
      });
    }

    this.applyChangeFunctions();
  },
  _wrapRemove: function _wrapRemove() {
    var originalRemove = this.remove;
    this.remove = _underscore.default.bind(function () {
      this.removeValidation();
      this.remove = originalRemove;
      return originalRemove.call(this);
    }, this);
  },
  _valid: function _valid(view, attr) {
    var errorElement = view.$('.error-' + attr);
    errorElement.text('');
    errorElement.removeClass('error-visible').addClass('error-hidden');
  },
  _invalid: function _invalid(view, attr, error) {
    if (view.ignoreErrors && view.ignoreErrors.indexOf(error) != -1) {
      view._valid(view, attr);

      return;
    }

    var errorElement = view.$('.error-' + attr);
    errorElement.text(error);
    errorElement.addClass('error-visible').removeClass('error-hidden');
  },
  _bindModelToView: function _bindModelToView(bindToAttrs) {
    var thisView = this;

    _underscore.default.each(bindToAttrs, function (attr) {
      var changeEvent = 'change:' + attr;

      var changeFunction = function changeFunction() {
        var value = this._modelTransform(attr, thisView.model.get(attr));

        var $el = this.$('[name="' + attr + '"]');
        var tagName = $el.prop('tagName');
        var $checkbox = this.$('[name=checkboxField]');

        if ($checkbox.length > 0 && value) {
          _underscore.default.each($checkbox, function (ch) {
            if (Array.isArray(value)) {
              if (value.findIndex(function (item) {
                return item === ch.value;
              }) !== -1) {
                (0, _jquery.default)(ch).prop('checked', true);
                thisView._formViewMixinOptions.enhance.icheck && (0, _jquery.default)(ch).icheck('updated');
              } else {
                (0, _jquery.default)(ch).prop('checked', false);
                thisView._formViewMixinOptions.enhance.icheck && (0, _jquery.default)(ch).icheck('unchecked');
              }
            }
          });
        }

        if (tagName == 'SELECT') {
          if ($el.hasClass('custom-multi-select')) {
            $el.val(value || []);
            $el.multiselect('refresh');
            this._formViewMixinOptions.enhance.icheck && this.applyIcheck();
          } else {
            $el.val(value);
            thisView._formViewMixinOptions.enhance.select && $el.hasClass('selectpicker') && $el.selectpicker('refresh');
          }
        } else if ($el.attr('type') == 'checkbox') {
          $el.prop('checked', value);
          thisView._formViewMixinOptions.enhance.icheck && $el.icheck('updated');
        } else if ($el.attr('type') == 'radio') {
          $el = this.$('[name="' + attr + '"][value="' + value + '"]');
          $el.prop('checked', true);
          thisView._formViewMixinOptions.enhance.icheck && $el.icheck('updated');
        } else if (tagName == 'INPUT' || tagName == 'TEXTAREA') {
          $el.val(value);
        } else {
          $el.text(value);
        }
      };

      this.changeFunctions.push(changeFunction);
      this.listenTo(this.model, changeEvent, changeFunction);
    }, this);
  },
  _bindViewToModel: function _bindViewToModel(bindToAttrs, ignoreKeyUp) {
    this.events = _underscore.default.result(this, 'events') || {};

    _underscore.default.each(bindToAttrs, function (attr) {
      var types = ['text', 'tel', 'password', 'number'];
      this.events['change [name="' + attr + '"]'] = '_formChanged';

      if (!ignoreKeyUp || ignoreKeyUp.indexOf(attr) < 0) {
        _underscore.default.each(types, function (type) {
          this.events['keyup [type="' + type + '"][name="' + attr + '"]'] = '_formKeyUp';
        }, this);

        this.events['keyup textarea[name="' + attr + '"]'] = '_formKeyUp';
        this.events['keyup input:not([type])[name="' + attr + '"]'] = '_formKeyUp';
      }

      _underscore.default.each(types, function (type) {
        this.events['blur [type="' + type + '"][name="' + attr + '"]'] = '_formBlur';
        this.events['focus [type="' + type + '"][name="' + attr + '"]'] = '_formFocus';
      }, this);

      this.events['blur input:not([type])[name="' + attr + '"]'] = '_formBlur';
      this.events['blur textarea[name="' + attr + '"]'] = '_formBlur';
    }, this);

    this.delegateEvents();
  },
  hideErrorMessage: function hideErrorMessage(view, attr) {
    var errorElement = view.$('.error-' + attr);
    errorElement.text('');
    errorElement.removeClass('error-visible').addClass('error-hidden');
  },
  _formChanged: function _formChanged(e) {
    var attr = e.currentTarget.name;
    var $el = (0, _jquery.default)(e.currentTarget);
    var type = e.currentTarget.type;
    var value = $el.attr('type') == 'checkbox' ? $el.is(':checked') : $el.val();
    var tagName = $el.prop('tagName');
    var oldValue = this.model.get(attr);

    this._updateModel(attr, value, false, type);

    this.trigger('form-change', attr, oldValue, value);
    this.trigger('form-change:' + attr, oldValue, value);
  },
  _formKeyUp: function _formKeyUp(e) {
    e = e || event;
    var tabKeyCode = 9;

    if (e.keyCode == tabKeyCode) {
      return;
    }

    var value = (0, _jquery.default)(e.target).val();
    var attr = e.target.name;
    var type = e.target.type;
    var silent = !this._formViewMixinOptions.liveKeyup;

    this._updateModel(attr, value, silent, type);
  },
  _formFocus: function _formFocus(e) {
    var attr = e.currentTarget.name;
    var value = (0, _jquery.default)(e.currentTarget).val();

    if (value !== undefined) {
      this.hideErrorMessage(this, attr);
    }
  },
  _formBlur: function _formBlur(e) {
    var attr = e.currentTarget.name;
    var type = e.currentTarget.type;
    var value = (0, _jquery.default)(e.currentTarget).val();

    if (!this._formViewMixinOptions.liveKeyup) {
      this._updateModel(attr, '_' + value, true, type);
    }

    this._updateModel(attr, value, false, type);
  },
  _multiSelectChanged: function _multiSelectChanged(selected) {
    var multiselect = (0, _jquery.default)(selected).parent();
    var value = multiselect.val() || [];

    this._updateModel(multiselect.attr('name'), value, false);
  },
  _viewTransform: function _viewTransform(attr, value) {
    if (this.viewTransformers && this.viewTransformers[attr]) {
      return this.viewTransformers[attr].call(this, value);
    }

    return value;
  },
  _modelTransform: function _modelTransform(attr, value) {
    if (this.modelTransformers && this.modelTransformers[attr]) {
      return this.modelTransformers[attr].call(this, value);
    }

    return value;
  },
  _updateModel: function _updateModel(attr, value, silent, type) {
    var largerThenIntCase = type === 'text' && value.length > 16;

    if (_underscore.default.isArray(value)) {
      this.model.set(attr, this._viewTransform(attr, value), {
        silent: silent,
        trackit_silent: silent
      });
    } else if (_underscore.default.isBoolean(value) || _underscore.default.isString(value) && value.length > 0) {
      var toNumber = parseInt(value, 10);

      if (value == toNumber && value.length === toNumber.toString().length && !largerThenIntCase) {
        value = parseInt(value, 10);
      }

      this.model.set(attr, this._viewTransform(attr, value), {
        silent: silent,
        trackit_silent: silent
      });
    } else {
      this.model.unset(attr, {
        silent: silent,
        trackit_silent: silent
      });
    }
  }
};

var _default = _underscore.default.extend(FormViewMixin, _TrackingMixin.default, SaveButtonMixin);

exports.default = _default;